import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TestStudio from './components/TestStudio/TestStudio.jsx';
import HostShell from './components/HostView/Shell.jsx';
import PlayerShell from './components/PlayerView/Shell.jsx';
import GalleryView from './components/Gallery/GalleryView.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<PlayerShell />} />
      <Route path="/host" element={<HostShell />} />
      <Route path="/test" element={<TestStudio />} />
      <Route path="/gallery" element={<GalleryView />} />
      <Route
        path="/about"
        element={
          <div style={{ padding: '32px', textAlign: 'center' }}>
            <h1>About SoundDrift</h1>
            <p>Memedrift.com Jackbox-style audio game</p>
          </div>
        }
      />
      <Route
        path="/admin"
        element={
          <div style={{ padding: '32px', textAlign: 'center' }}>
            <h1>Admin Panel</h1>
          </div>
        }
      />
    </Routes>
  );
}

